





import { Component, Vue } from 'vue-property-decorator';
import Searchbox from './Searchbox.vue';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Loader from './Loader.vue';
import Broadcast from './Broadcast.vue';
import Joblisting from './Joblisting.vue';
import JobAlertUI from './JobAlertUI.vue';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import SurveyFileUpload from './SurveyFileUpload.vue';
import {
  SurveyDetailRequest,
  SurveyQuestionResponse,
  SurveyFieldValidation
} from '../../../models/candidatesurvey/candidatesurveyresponse';
import { QuestionResponseData } from '../../../models/jobs/questionnaireresponse';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import Datepicker from 'vuejs-datepicker';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Multiselect from 'vue-multiselect';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
import {
  SURVEY_DETAILS_SUCCESS_MESSAGE,
  SURVEY_QUESTION_CODE_TEXT,
  SURVEY_QUESTION_CODE_MULTIPLE_CHOICE,
  SURVEY_QUESTION_CODE_RADIO,
  SURVEY_QUESTION_CODE_RATING,
  SURVEY_FEEDBACK_QUESTION_CODE_TEXT,
  RATING_F_QUES_CONDITION_ID_EQUAL,
  RATING_F_QUES_CONDITION_ID_GREATER_THAN,
  RATING_F_QUES_CONDITION_ID_LESS_THAN,
  SURVEY_DETAILS_ERROR_MESSAGE,
  CANDIDATE_PORTAL_SURVEY_TODAY_TEXT,
  SURVEY_DETAILS_DATA_FETCHING_MESSAGE,
  SURVEY_QUESTION_CODE_UPLOAD_FILE,
  SURVEY_QUESTION_CODE_DROPDOWN,
  SURVEY_QUESTION_CODE_DATE,
  SURVEY_END_MESSAGE
} from '../SurveyConstants';
import moment from 'moment';
import { Resume } from '../../../models/jobs/resume';
import { ResumeWrapper } from '../../../models/jobs/resumeWrapper';
import ConfirmationModalV2 from '@/components/Commons/ConfirmationModalV2.vue';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'SurveyPage',
  components: {
    SurveyFileUpload,
    Datepicker,
    Multiselect
  },
})
export default class SurveyPage extends Vue {
  public isRotated: boolean = false;
  private surveyBranchingEnabled: boolean = false;
  public isLoading: boolean = false;
  public isSurveySuccessfullySubmitted: boolean = false;
  private messageResponseTemplate = '';
  public hasServerResponseArrived: boolean = false;
  public surveyData: any[] = [];
  public $wlToastr: any;
  public test:any;
  public isSurveySubmitBtnEnabled: boolean = false;
  private answeredQuestions: any[] = [];
  private requiredQuestionCount = 0;
  public surveyDetailsData: any;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  public endSurveyMessage : string = '';
  private showSurveySubmitScreen: boolean = false;
  private previousHasNextQuestion: any = null;
  private backupResponse: any = null;
  private isSurveySubmitted: boolean = false;
  private phoneNumber:string='';
  public feedbackQuestionTitle = {
    key: '',
  };
  public displayMessageTitle = {
    key: '',
  };
  private emailRegex: RegExp = new RegExp(
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
  );
  private alphaRegex: RegExp = new RegExp(
    /^[a-zA-Z ]+$/,
  );
  private alphaNumericRegex: RegExp = new RegExp(
    /^[a-zA-Z0-9 ]*$/,
  );
  private isValidEmail: boolean = false;
  private isPhoneValid: boolean = false;
  private isValidPhone: boolean = false;
  private isValidDate: boolean = false;
  private isTypeable: boolean = true;

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get canShowSurveyMessage() {
    return vxm.configs.getGlobalConfigValue('SHOW_SURVEY_MESSAGE')
  }

  initHightLightRatingCircle(answerIndex, index) {
    if (index === answerIndex) {
      return { 'background-color': '#3D91F2' };
    } else {
      return { 'background-color': 'transparent' };
    }
  }
  listResumes() {
    const token = vxm.users.getToken;
    vxm.jobs.getResumeListing(token).then(() => {
      this.resumeListing = vxm.jobs.resumeListing;
    });
    return this.resumeListing.resumes.length>0 ? true : false;
  }

  highlightLeftRating(question, index, answerMasterID) {
    let arr: any = this.$refs['rating_' + question.questionID];
    let size = arr.length;
    for (let i = 0; i < size; i++) {
      arr[i].style['background-color'] = 'transparent';
    }
    arr[index].style['background-color'] = '#3D91F2';
    if (question.userQuestionResponse && question.userQuestionResponse) {
      question.userQuestionResponse.userAnswerList = answerMasterID;
    }
    this.enableSurveySubmitBtn(question);
  }

  getRatingStickWidth(size) {
    return { width: `calc(100% / ${size})` };
  }

  formatDateToDayDateMonthYear(timestamp: any) {
    if (moment(timestamp).isSame(moment(), 'day')) {
      return CANDIDATE_PORTAL_SURVEY_TODAY_TEXT;
    } else if (Number.isInteger(timestamp) && timestamp) {
      return moment(timestamp).format('ddd, Do MMM, YYYY');
    } else return new Date(timestamp).toLocaleString();
  }
  onResumeUploadSuccess() {
    const uploadQuestion = this.surveyData[0].questions.find(
    q => q.questionType === SURVEY_QUESTION_CODE_UPLOAD_FILE
    );
    if (uploadQuestion && uploadQuestion.userQuestionResponse) {
      uploadQuestion.userQuestionResponse.questionTextResponse = 'Resume uploaded';
    }
    this.enableSurveySubmitBtn(uploadQuestion)
  }
  onRemovingResume(){
    const uploadQuestion = this.surveyData[0].questions.find(
    q => q.questionType === SURVEY_QUESTION_CODE_UPLOAD_FILE
    );
    if (uploadQuestion && uploadQuestion.userQuestionResponse) {
      uploadQuestion.userQuestionResponse.questionTextResponse = '';
    }
    this.enableSurveySubmitBtn(uploadQuestion)
  }


  enableSurveySubmitBtn(question) {
    let index = this.isQuestionPresentInArr(question);
    if (index >= 0) {
      this.answeredQuestions[index] = question;
    } else {
      this.answeredQuestions.push(question);
    }
    let showFeedbackQuestion = this.showFeedbackQuestion(question);
    this.showDisplayMessage(question);
   
    if (question.feedbackQuestionList && Array.isArray(question.feedbackQuestionList) && question.feedbackQuestionList.length) {
      let feedBackQuestionIds = question.feedbackQuestionList.map(question => question.questionID)
      let feedBackNonSelectedQuestionIds = this.lodash.filter(feedBackQuestionIds, (id) => {
          return id !== this.feedbackQuestionTitle[question.questionID] 
      })
      if (!question.showFeedbackQuestion) {
        feedBackNonSelectedQuestionIds = feedBackQuestionIds
      }
      this.answeredQuestions = this.lodash.filter(this.answeredQuestions, (answeredQuestion) => {
          return !feedBackNonSelectedQuestionIds.includes(answeredQuestion.questionID)
      })

      const currentFeedbackQuestion = question.feedbackQuestionList.find(feedbackQuestion => feedbackQuestion.questionID ===this.feedbackQuestionTitle[question.questionID])
      if (question.showFeedbackQuestion && currentFeedbackQuestion && currentFeedbackQuestion.userQuestionResponse && currentFeedbackQuestion.userQuestionResponse.questionTextResponse) {
        let hasAlreadyPresent = this.answeredQuestions.find(answeredQuestion => answeredQuestion.questionID === currentFeedbackQuestion.questionID)
        !hasAlreadyPresent && this.answeredQuestions.push(currentFeedbackQuestion)
      }
    }
    if (
      question.feedbackQuestion &&
      showFeedbackQuestion &&
      question.feedbackQuestion.userQuestionResponse &&
      question.feedbackQuestion.userQuestionResponse.questionTextResponse
    ) {
      question.feedbackQuestion.status = '1';
    } else if (question.feedbackQuestion && !showFeedbackQuestion) {
      question.feedbackQuestion.status = '0';
    }
    let size = this.answeredQuestions.filter(
      (item) => item.questionRequired && this.isQuestionAnswered(item),
    ).length;
    this.isSurveySubmitBtnEnabled = this.requiredQuestionCount === size;

  }

  showMultipleChoiceFeedbackQuestion(question): boolean {
    let feedbackQuestionConditionValues = question.feedbackQuestionList;
    let userQuestionResponse
    if (Array.isArray(question.userQuestionResponse.userAnswerList)) {
      userQuestionResponse = question.userQuestionResponse.userAnswerList
    } else {
      userQuestionResponse = [question.userQuestionResponse.userAnswerList]
      question.userQuestionResponse.userAnswerList = [question.userQuestionResponse.userAnswerList]
    }
    let userQuestionResponseValue = {};
    if (question.answerList) {
      for (let value of question.answerList) {
        if (
          userQuestionResponse.find(
            (selectedValue) => selectedValue === value.answerMasterID,
          )
        ) {
          userQuestionResponseValue[value.answerValue] = value.answerValue;
        }
      }
    }
    var resp = this.userResponse(userQuestionResponseValue);
    var respArray = resp.split(',');
    if (feedbackQuestionConditionValues) {
      for (let value of feedbackQuestionConditionValues) {
        if (!value.userQuestionResponse) {
          value.userQuestionResponse = {
            questionTextResponse: '',
          };
        }
        let notPresentInResp = respArray.filter(
          (val) => !value.feedbackQuestionConditionValue.includes(val),
        );
        let notPresentInAnswerList = value.feedbackQuestionConditionValue.filter(
          (val) => !resp.includes(val),
        );
        if (
          respArray.length === value.feedbackQuestionConditionValue.length &&
          notPresentInResp.length === 0 &&
          notPresentInAnswerList.length === 0
        ) {
          question.showFeedbackQuestion = true;
          this.feedbackQuestionTitle[question.questionID] = value.questionID;
          return true;
        }
      }
    }
    question.showFeedbackQuestion = false;
    return false;
  }

  userResponse(userQuestionResponseValue) {
    var userQuestionResponseValues = '';
    for (const obj of Object.entries(userQuestionResponseValue)) {
      userQuestionResponseValues += obj + ',';
    }
    userQuestionResponseValues = userQuestionResponseValues.replace(
      /,\s*$/,
      '',
    );
    var respAsArray = userQuestionResponseValues
      .split(',')
      .filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
      });
    return respAsArray.join(',');
  }

  showRadioTypeFeedbackQuestion(question) {
    let userQuestionResponse = question.userQuestionResponse.userAnswerList;
    let feedbackQuestionConditionValues = question.feedbackQuestionList;
    if (question.answerList) {
      for (let value of question.answerList) {
        if (value.answerMasterID === userQuestionResponse) {
          if (feedbackQuestionConditionValues) {
            for (let conditionValue of feedbackQuestionConditionValues) {
              if (!conditionValue.userQuestionResponse) {
                conditionValue.userQuestionResponse = {
                  questionTextResponse: '',
                };
              }
              if (
                value.answerValue ==
                conditionValue.feedbackQuestionConditionValue
              ) {
                question.showFeedbackQuestion = true;
                this.feedbackQuestionTitle[question.questionID] =
                  conditionValue.questionID;
                return true;
              }
            }
          }
        }
      }
    }
    question.showFeedbackQuestion = false;
    return false;
  }

  showRatingTypeFeedbackQuestion(question, relaxDomCheck = false) {
    question.showFeedbackQuestion = false;
    let userResponse = Array.isArray(
      question.userQuestionResponse.userAnswerList,
    )
      ? question.userQuestionResponse.userAnswerList[0]
      : question.userQuestionResponse.userAnswerList;
    for (let value of question.answerList || []) {
      if (value.answerMasterID === userResponse) {
        for (let feedbackQuestion of question.feedbackQuestionList || []) {
          if (!feedbackQuestion.userQuestionResponse) {
            feedbackQuestion.userQuestionResponse = {
              questionTextResponse: '',
            };
          }
          if (question.showFeedbackQuestion) {
            break;
          }
          switch (feedbackQuestion.feedbackQuestionConditionID[0]) {
            case RATING_F_QUES_CONDITION_ID_LESS_THAN:
              if (
                value.answerRating <
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                for (let feedbackQuestion2 of question.feedbackQuestionList || []) {
                  feedbackQuestion2.showFeedbackQuestion = false;
                }
                feedbackQuestion.showFeedbackQuestion = true;
                question.feedbackQuestion = feedbackQuestion;
                question.showFeedbackQuestion = true;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_GREATER_THAN:
              if (
                value.answerRating >
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                
                for (let feedbackQuestion2 of question.feedbackQuestionList || []) {
                  feedbackQuestion2.showFeedbackQuestion = false;
                }
                feedbackQuestion.showFeedbackQuestion = true;
                question.showFeedbackQuestion = true;
                question.feedbackQuestion = feedbackQuestion;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_EQUAL:
              if (
                value.answerRating ===
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                for (let feedbackQuestion2 of question.feedbackQuestionList || []) {
                  feedbackQuestion2.showFeedbackQuestion = false;
                }
                feedbackQuestion.showFeedbackQuestion = true;
                question.showFeedbackQuestion = true;
                question.feedbackQuestion = feedbackQuestion;
                return true;
              }
              break;
          }
        }
      }
    }
    if (this.$refs['feedback_question_' + question.questionID]) {
      question.showFeedbackQuestion = false;
    }
    return false;
  }

  showFeedbackQuestion(question): boolean {
    if (question.feedbackQuestion) {
      if (question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE) {
        return this.showMultipleChoiceFeedbackQuestion(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RADIO) {
        return this.showRadioTypeFeedbackQuestion(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RATING) {
        return this.showRatingTypeFeedbackQuestion(question);
      } else {
        return false;
      }
    }
    return false;
  }

  showDisplayMessage(question) {
    if (question.displayMessages) {
      if (question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE) {
        this.showMultipleChoiceDisplayMessage(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RADIO) {
        this.showRadioTypeDisplayMessage(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RATING) {
        this.showRatingTypeDisplayMessage(question);
      }
    }
  }

  showMultipleChoiceDisplayMessage(question): boolean {
    // question.userQuestionResponse.userAnswerList
    var userAnsweredValues= [];
    if(question.userQuestionResponse &&  question.userQuestionResponse!=null && question.userQuestionResponse.hasOwnProperty('userAnswerList')){
      userAnsweredValues = question.userQuestionResponse.userAnswerList

    }


    if(((question.hasOwnProperty('userQuestionResponse') && question.userQuestionResponse!=null && question.userQuestionResponse.userAnswerList && question.userQuestionResponse.userAnswerList.length>0)  || 
    (question.mappedAttributeValues && question.mappedAttributeValues.length>0))  && 
   ( question.userQuestionResponse==null || !question.userQuestionResponse.hasOwnProperty('userMultiSelectList')) ){

      var mappedAttributeValues=false;
     
      if( question.userQuestionResponse==null &&
      question.mappedAttributeValues !=null && question.mappedAttributeValues.length>0){
        mappedAttributeValues=true
       userAnsweredValues = question.mappedAttributeValues

     }
     question.userQuestionResponse={}
      question.userQuestionResponse.userAnswerList=[]
      question.userQuestionResponse.userMultiSelectList=[]
    for(var i=0; i<userAnsweredValues.length;i++){
      for(var j=0;j<question.answerList.length;j++){
      if(!mappedAttributeValues && userAnsweredValues[i] === question.answerList[j].answerMasterID){
        question.userQuestionResponse.userAnswerList.push(question.answerList[j].answerMasterID)
        question.userQuestionResponse.userMultiSelectList.push(question.answerList[j])

    
      }
      else if(mappedAttributeValues && userAnsweredValues[i] == question.answerList[j].targetFieldValue){
        question.userQuestionResponse.userAnswerList.push(question.answerList[j].answerMasterID)
        question.userQuestionResponse.userMultiSelectList.push(question.answerList[j])

      }
    }
    }
  }
  // adding a new value to the multiselect
  else if( question.userQuestionResponse && question.userQuestionResponse.userMultiSelectList){

    if(  question.userQuestionResponse.userMultiSelectList.length> question.userQuestionResponse.userAnswerList.length){

      for(var i=0;i<question.userQuestionResponse.userMultiSelectList.length;i++){
        if(!question.userQuestionResponse.userAnswerList.includes(question.userQuestionResponse.userMultiSelectList[i].answerMasterID)){
          question.userQuestionResponse.userAnswerList.push(question.userQuestionResponse.userMultiSelectList[i].answerMasterID)

          break;
        }
      }
    }
    else{

      if(question.userQuestionResponse && question.userQuestionResponse.userAnswerList){
      for(var i=0;i<question.userQuestionResponse.userAnswerList.length;i++){
        var matched = false;
        for(var j=0;j<question.userQuestionResponse.userMultiSelectList.length;j++){
          if(question.userQuestionResponse.userAnswerList[i] == question.userQuestionResponse.userMultiSelectList[j].answerMasterID){
       matched =true
         break

          }

          }
          if(!matched){
            question.userQuestionResponse.userAnswerList.splice(i, 1);
            break;
          }
        }

    }
  }
  }


    let displayMessageConditionValues = question.displayMessages;
    let userQuestionResponse;
    if (Array.isArray(question.userQuestionResponse.userAnswerList)) {
      userQuestionResponse = question.userQuestionResponse.userAnswerList;
    } else {
      userQuestionResponse = [question.userQuestionResponse.userAnswerList];
      question.userQuestionResponse.userAnswerList = [
        question.userQuestionResponse.userAnswerList,
      ];
    }
    let userQuestionResponseValue = {};
    if (question.answerList) {
      for (let value of question.answerList) {
        if (
          userQuestionResponse.find(
            (selectedValue) => selectedValue === value.answerMasterID,
          )
        ) {
          userQuestionResponseValue[value.answerValue] = value.answerValue;
        }
      }
    }
    var resp = this.userResponse(userQuestionResponseValue);
    var respArray = resp.split(',');
    if (displayMessageConditionValues) {
      for (let value of displayMessageConditionValues) {
        let notPresentInResp = respArray.filter(
          (val) => !value.feedbackQuestionConditionValue.includes(val),
        );
        let notPresentInAnswerList = value.feedbackQuestionConditionValue.filter(
          (val) => !resp.includes(val),
        );
        if (
          respArray.length === value.feedbackQuestionConditionValue.length &&
          notPresentInResp.length === 0 &&
          notPresentInAnswerList.length === 0
        ) {
          question.showDisplayMessage = true;
          this.displayMessageTitle[question.questionID] = value.questionID;
          return true;
        }
      }
    }
    question.showDisplayMessage = false;
    return false;
  }

  showRadioTypeDisplayMessage(question) {
        if(question.userQuestionResponse && Array.isArray(question.userQuestionResponse.userAnswerList) && (question.userQuestionResponse.userAnswerList.length>0 ||  question.mappedAttributeValue)  && !question.userQuestionResponse.userSingleSelect){
          var userAnsweredValues = question.userQuestionResponse.userAnswerList
    question.userQuestionResponse.userAnswerList=[]
    var mappedAttributeValue = false;
    if( question.mappedAttributeValue){
      userAnsweredValues=  question.mappedAttributeValue
      mappedAttributeValue = true
    }

  
      for(var j=0;j<question.answerList.length;j++){
      if(!mappedAttributeValue && userAnsweredValues[0] == question.answerList[j].answerMasterID){
        question.userQuestionResponse.userSingleSelect = question.answerList[j]
        question.userQuestionResponse.userAnswerList.push(question.answerList[j].answerMasterID)
        break;
      }
      else if(mappedAttributeValue && userAnsweredValues[0] == question.answerList[j].targetFieldValue){
        question.userQuestionResponse.userSingleSelect = question.answerList[j]
        question.userQuestionResponse.userAnswerList.push(question.answerList[j].answerMasterID)
        break;

      }
    }
    
  }
  else if( question.userQuestionResponse.userSingleSelect ){
    if(question.userQuestionResponse.userSingleSelect ){
      question.userQuestionResponse.userAnswerList=[]
          question.userQuestionResponse.userAnswerList= (question.userQuestionResponse.userSingleSelect.answerMasterID)      
    }
    else{
      question.userQuestionResponse.userSingleSelect=null  

    }


  }


    let displayMessageConditionValues = question.displayMessages;
    if (question.answerList) {
      for (let value of question.answerList) {
        if (value.answerMasterID == question.userQuestionResponse.userAnswerList) {
          if (displayMessageConditionValues) {
            for (let conditionValue of displayMessageConditionValues) {
              if (
                value.answerValue ==
                conditionValue.feedbackQuestionConditionValue
              ) {
                question.showDisplayMessage = true;
                this.displayMessageTitle[question.questionID] =
                  conditionValue.questionID;
                return true;
              }
            }
          }
        }
      }
    }
    question.showDisplayMessage = false;
    return false;
  }

  showRatingTypeDisplayMessage(question) {
    question.showDisplayMessage = false;
    let userResponse = Array.isArray(
      question.userQuestionResponse.userAnswerList,
    )
      ? question.userQuestionResponse.userAnswerList[0]
      : question.userQuestionResponse.userAnswerList;
    for (let value of question.answerList || []) {
      if (value.answerMasterID === userResponse) {
        for (let displayMessage of question.displayMessages || []) {
          if (question.showDisplayMessage) {
            break;
          }
          switch (displayMessage.feedbackQuestionConditionID[0]) {
            case RATING_F_QUES_CONDITION_ID_LESS_THAN:
              if (
                  value.answerRating <
                  Number(displayMessage.feedbackQuestionConditionValue[0])
              ) {
                question.showDisplayMessage = true;
                this.displayMessageTitle[question.questionID] =
                  displayMessage.questionID;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_GREATER_THAN:
              if (
                  value.answerRating >
                  Number(displayMessage.feedbackQuestionConditionValue[0])
              ) {
                question.showDisplayMessage = true;
                this.displayMessageTitle[question.questionID] =
                  displayMessage.questionID;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_EQUAL:
              if (
                  value.answerRating ===
                  Number(displayMessage.feedbackQuestionConditionValue[0])
              ) {
                question.showDisplayMessage = true;
                this.displayMessageTitle[question.questionID] =
                  displayMessage.questionID;
                return true;
              }
              break;
          }
        }
      }
    }
    question.showDisplayMessage = false;
    return false;
  }

  isQuestionPresentInArr(question) {
    return this.answeredQuestions.findIndex(
      (k) => k.questionID === question.questionID,
    );
  }

  mounted() {
    vxm.utility.setSpinnerStatus(true);
    this.getSurveyPageData();
    vxm.users.setRouteAfterLogin('SurveyPage');
  }

  async saveCurrentQuestion(event?: any) {
    let isAnswerValid: boolean = true;
    let isDataFieldValid;
    let requiredDataFieldValidation : boolean = false;
    let respPromise : any;
    let dataValidationQuestionCount = 0 ;
    for (let question of this.answeredQuestions) { 
      isAnswerValid = this.validatePhoneAndEmailFields(question, isAnswerValid);   
    }
    if (!isAnswerValid) {
      return;
    }
    const surveyuserqualifierid = vxm.users.getSurveyuserqualifierid
    let surveyQuestionResponse: SurveyQuestionResponse = this.prepareSurveyRequestPayload(
      surveyuserqualifierid
    );
    this.isSurveySuccessfullySubmitted = false;
    for (let question of this.answeredQuestions) {
      dataValidationQuestionCount = 0;
      if(question && question.validation && question.validation.dataValidation && question.userQuestionResponse.questionTextResponse.length > 0){
        requiredDataFieldValidation = true;
        dataValidationQuestionCount = dataValidationQuestionCount + 1;
        if(question.userQuestionResponse){
          isDataFieldValid =  await this.surveyFieldValidation(question);
        }
        if(isDataFieldValid.status != 200){
         requiredDataFieldValidation = false; 
         this.$wlToastr('error',isDataFieldValid.errors[0].description); 
         break;
        } 
      }    
    }

  if(dataValidationQuestionCount === 0 || requiredDataFieldValidation ){
      respPromise = vxm.jobs.saveSurveyResponse(
        surveyQuestionResponse,
   );
  }
   if(event){
        this.showSaveToaster(respPromise);
    }
    requiredDataFieldValidation = false;
    return respPromise;
  }

  showSaveToaster(respPromise: any, fetchData?: boolean){
    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((values) => {
      if (values[0]) {
        if (values[0].success) {
          this.$wlToastr(
            'success',
            SURVEY_DETAILS_SUCCESS_MESSAGE,
            this.$t('candidate-survey-text'),
          );
          this.$modal.hide('survey-spinner');
          if(fetchData){
            this.getSurveyPageData();
          }
        } else {
          this.$modal.hide('survey-spinner');
          this.$wlToastr('error', values[0].errorMessage, this.$t('candidate-survey-text'));
        }
      }
    });
  }

  async getSurveyPageData(navigation = '', questionId?: number) {
    let saveQuestioResp;
    let respPromise1;
    let surveyDetailRequest: SurveyDetailRequest = new SurveyDetailRequest();
    var userId = this.$route.params.userid;
    var surveyuserqualifierid = this.$route.params.surveyuserqualifierid;
    if (!userId) {
      userId = this.$route.query.userid + '';
    }
    if (!surveyuserqualifierid) {
      surveyuserqualifierid = this.$route.query.surveyuserqualifierid + '';
    }
    vxm.users.setUserID(userId);
    vxm.users.setSurveyuserqualifierid(surveyuserqualifierid);
    surveyDetailRequest.userId = parseInt(userId, 10);
    surveyDetailRequest.surveyUserQualifierId = surveyuserqualifierid;
    if (navigation === 'next') {
      surveyDetailRequest.navigation = navigation
      surveyDetailRequest.questionID = this.surveyData[0].questions[0].questionID
      if ( this.answeredQuestions && this.answeredQuestions[0]) {
        if (Array.isArray(this.answeredQuestions[0].userQuestionResponse.userAnswerList)) {
          surveyDetailRequest.answerIds = this.answeredQuestions[0].userQuestionResponse.userAnswerList
        } else {
          surveyDetailRequest.answerIds = [this.answeredQuestions[0].userQuestionResponse.userAnswerList]
        }
      }

      if(!this.isSurveySubmitted){
        saveQuestioResp =  await this.saveCurrentQuestion();
      } 
    }
    if (navigation === 'previous') {
      surveyDetailRequest.questionID =  questionId || this.surveyData[0].questions[0].questionID
      surveyDetailRequest.navigation = navigation
    }
    this.$modal.show('survey-spinner');
    if(navigation === 'next' && saveQuestioResp){
       respPromise1 = vxm.jobs.getCandidateSurveyDetails(surveyDetailRequest);
    }
    else if(navigation === 'previous' || navigation === ''){
       respPromise1 = vxm.jobs.getCandidateSurveyDetails(surveyDetailRequest);
    }
    this.previousHasNextQuestion = navigation && this.surveyData[0].survey.hasNextQuestion
    this.backupResponse = this.surveyData
    Promise.all([respPromise1]).then(
      (response) => {
        if (response) {
          this.surveyData = JSON.parse(JSON.stringify(this.processSurveyResponse(response)))
          if (this.surveyBranchingEnabled && !this.surveyData[0].questions.length) {
            if (!this.previousHasNextQuestion) {
              this.submitSurvey(this.surveyData[0].questions, vxm.users.getSurveyuserqualifierid)
            } else {
              this.showSurveySubmitScreen = true
            }
          }
        }
        this.hasServerResponseArrived = true;
        this.$modal.hide('survey-spinner');

      },
      (err) => {
        this.$modal.hide('survey-spinner');
        this.$wlToastr(
          'error',
          SURVEY_DETAILS_ERROR_MESSAGE,
          this.$t('candidate-survey-text'),
        );
      },
    );
  }

  processSurveyResponse(surveyData) {
    // surveyData[0].questions.push({ questionType : '90' , questionDesc : 'Thank you we have recived your response'});
    this.isSurveySubmitBtnEnabled = false;
    let requiredQuestionCount: number = 0;
    let answeredQuestionCount: number = 0;
    let answeredRequiredQuestionCount: number = 0;
    this.answeredQuestions = [];
    surveyData[0].questions.forEach((question) => {
      if (question.questionType === SURVEY_END_MESSAGE) {
        this.endSurveyMessage = `<div style='padding: 50px 0px; font-size: 20px;'> ${
          question.questionDesc
        }</div>`;
      }
      if (question.questionType === SURVEY_QUESTION_CODE_RATING) {
        question.userQuestionResponse &&
          this.showRatingTypeFeedbackQuestion(question, true);
      }
        if(question.questionType === SURVEY_QUESTION_CODE_UPLOAD_FILE){
        if(vxm.users.isLoggedIn){
            const isResumesPresent = this.listResumes();
            console.log("this.listResumes",isResumesPresent)
            if(isResumesPresent){
              question.userQuestionResponse = { questionTextResponse: 'Resume uploaded' };
            }
            else{
               question.userQuestionResponse = { questionTextResponse: '' };
            }
        }
        else{
          question.userQuestionResponse = { questionTextResponse: '' };
        }
      }
      if (question.userQuestionResponse || (question.mappedAttributeValues && question.mappedAttributeValues.length >0) || question.mappedAttributeValue) {
        if(question.userQuestionResponse ){
        this.showMultipleChoiceFeedbackQuestion(question);
        this.showRadioTypeFeedbackQuestion(question);
        }
        this.showDisplayMessage(question);

        if (
          question.questionType === '04' &&
          question.userQuestionResponse &&
          question.userQuestionResponse.questionTextResponse.length > 0 &&
          question.validation &&
          question.validation.type === 'PHONE'
        ) {
          this.phoneNumber = question.userQuestionResponse.questionTextResponse;
        }
      }
 

      if (
        !question.userQuestionResponse &&
        (question.mappedAttributeValue || question.mappedAttributeValues)
      ) {
        if (question.questionType === '04') {
        question.userQuestionResponse = {
          questionTextResponse: question.mappedAttributeValue || '',
          questionDateResponse: this.getSurveyPhone(question) || '',
          userAnswerList: [],
        };
        } else if (question.questionType === SURVEY_QUESTION_CODE_DATE) {
          question.userQuestionResponse = {
            questionTextResponse: new Date(question.mappedAttributeValue)
            .toISOString()
            .split('T')[0] || '',
          };
        } else if (
          question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE
        ) {
          let userAnswerList: any[] = [];
          for (var i = 0; i < question.mappedAttributeValues.length; i++) {
            for (var j = 0; j < question.answerList.length; j++) {
              if (
                question.mappedAttributeValues[i] ==
                question.answerList[j].targetFieldValue
              ) {
                if (question.questionRequired) {
                  answeredQuestionCount = answeredQuestionCount - 1;
                }
                userAnswerList.push(question.answerList[j].answerMasterID);
              }
            }
      }
          question.userQuestionResponse = {
            userAnswerList: userAnswerList || [],
          };
        }
      }
      if (
        question.userQuestionResponse &&
        question.questionType === '04' &&
        question.mappedAttributeValue
      ) {
        question.userQuestionResponse.questionDateResponse = this.getSurveyPhone(
          question,
        );
        if (
          question.userQuestionResponse.questionDateResponse.length > 0 &&
          this.phoneNumber.length == 0
        ) {
          this.phoneNumber = question.userQuestionResponse.questionDateResponse;
        }
      }

      if (this.isQuestionAnswered(question)) {
        this.answeredQuestions.push(question);
        answeredQuestionCount++;
        if (question.questionRequired) {
          answeredRequiredQuestionCount++;
        }
      }
      if (
        question.feedbackQuestion &&
        this.isQuestionAnswered(question.feedbackQuestion)
      ) {
        this.answeredQuestions.push(question.feedbackQuestion);
        answeredQuestionCount++;
      }
      if (question.questionRequired) {
        requiredQuestionCount++;
      }
      if (
        question.feedbackQuestion &&
        question.feedbackQuestion.questionRequired
      ) {
        requiredQuestionCount++;
      }
      if (
        (question.questionType === SURVEY_QUESTION_CODE_RADIO ||
          question.questionType === SURVEY_QUESTION_CODE_RATING ||
          question.questionType === SURVEY_QUESTION_CODE_DROPDOWN) &&
        question.userQuestionResponse &&
        question.userQuestionResponse.userAnswerList
      ) {
        question.userQuestionResponse.userAnswerList =
          question.userQuestionResponse.userAnswerList[0];
        if (
          question.questionType === SURVEY_QUESTION_CODE_RATING &&
          question.userQuestionResponse &&
          question.userQuestionResponse.userAnswerList
        ) {
          let answerId = question.userQuestionResponse.userAnswerList;
          let ind = question.answerList.findIndex(
            (answer) => answer.answerMasterID === answerId,
          );

          question.answerIndex = ind;
        }
      } else if (
        !question.userQuestionResponse &&
        question.questionType === '04'
      ) {
        question.userQuestionResponse = { questionTextResponse: '' };
      } else if (!question.userQuestionResponse) {
        question.userQuestionResponse = {
          questionTextResponse: '',
          userAnswerList: [],
        };
      }

      if (
        question.feedbackQuestion &&
        !question.feedbackQuestion.userQuestionResponse
      ) {
        question.feedbackQuestion.userQuestionResponse = {
          questionTextResponse: '',
        };
        if (
          question.feedbackQuestion.questionType === '10' &&
          question.feedbackQuestion.userQuestionResponse
            .questionTextResponse === ''
        ) {
          question.feedbackQuestion.userQuestionResponse.questionTextResponse =
            '  ';
        }
      }
      question.showFeedbackQuestion =
        question.feedbackQuestion &&
        question.feedbackQuestion.userQuestionResponse &&
        question.feedbackQuestion.userQuestionResponse.questionTextResponse
          ? true
          : false;
      if (question.showFeedbackQuestion) {
        question.feedbackQuestion.status = '1';
      } else if (question.feedbackQuestion) {
        question.feedbackQuestion.status = '0';
      }
    });
    this.requiredQuestionCount = requiredQuestionCount;
    if (
      this.requiredQuestionCount === 0 ||
      this.requiredQuestionCount === answeredRequiredQuestionCount
    ) {
      this.isSurveySubmitBtnEnabled = true;
    }
    surveyData[0].questions = surveyData[0].questions.filter(question => question.questionType !== SURVEY_END_MESSAGE)
    this.surveyBranchingEnabled = surveyData[0].survey.hasBranch;
    //surveyData[0].survey.surveyStatus = 'Submitted'
    this.isSurveySubmitted = surveyData[0].survey.surveyStatus === 'Submitted'
    return surveyData;
  }


  onInput(question) {
    if (this.$refs['question_span2' + question.questionID]) {
      this.$refs['question_span2' + question.questionID][0].textContent =
        '(' +
        question.userQuestionResponse.questionTextResponse.length +
        '/' +
        question.maxLength +
        ')';
    }
    if (
      question.status &&
      question.status === '0' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length > 1
    ) {
      question.status = '1';
    } else if (
      question.status &&
      question.status === '1' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length === 0
    ) {
      question.status = '0';
    }

    this.enableSurveySubmitBtn(question);
  }

  isAllRequiredQuestionAnswered() {
    let isQuestionAnswered: boolean = true;
    for (let question of this.answeredQuestions) {
      if (
        (question.questionType === SURVEY_QUESTION_CODE_TEXT ||
          question.questionType === SURVEY_FEEDBACK_QUESTION_CODE_TEXT) &&
        this.$refs['question_span1' + question.questionID] &&
        question.minLength &&
        question.userQuestionResponse.questionTextResponse.length > 0 &&
        question.minLength >
          question.userQuestionResponse.questionTextResponse.length
      ) {
        this.$refs['question_span1' + question.questionID][0].focus();
        this.$refs[
          'question_span1' + question.questionID
        ][0].previousSibling.style['border-color'] = 'red';
        this.$refs['question_span1' + question.questionID][0].style.color =
          'red';
        isQuestionAnswered = false;
      }
      isQuestionAnswered = this.validatePhoneAndEmailFields(question, isQuestionAnswered);
    }
    return (
      isQuestionAnswered &&
      this.answeredQuestions.filter((question) => question.questionRequired)
        .length === this.requiredQuestionCount
    );
  }
  surveyFieldValidation(question){
    let surveyFieldValidationPayload :  SurveyFieldValidation = new SurveyFieldValidation();
    surveyFieldValidationPayload.companyID = vxm.jobs.CompanyInfo.companyId;
    surveyFieldValidationPayload.attributeKey = question.dataField;
    surveyFieldValidationPayload.locale= 'en-US';
    surveyFieldValidationPayload.value=question.userQuestionResponse.questionTextResponse;
    surveyFieldValidationPayload.values = [];
    const fieldSurveyResp = vxm.jobs.surveyFieldValidation(surveyFieldValidationPayload);
    return fieldSurveyResp;  
  }

  validatePhoneAndEmailFields(question, isAnswerValid){
    if (
      question.questionType === SURVEY_QUESTION_CODE_TEXT &&
      question.validation && question.validation.type
    ) {
      switch(question.validation.type){
        case 'EMAIL':
          if(!this.emailRegex.test(question.userQuestionResponse.questionTextResponse)){
            this.isValidEmail = true;
            isAnswerValid = false;
          } else {
            this.isValidEmail = false;
          }
          break;
        case 'PHONE':
          if(this.isPhoneValid){
            this.isValidPhone = true;
            isAnswerValid = false;
          } else {
            this.isValidPhone = false;
          }
          break;
        default:
          break;
      }
    }
    return isAnswerValid;
  }

  async submitSurvey(data: any, surveyUserQualifierId: string) {
    let dataValidationQuestionCount = 0;
    let requiredDataFieldValidation : boolean = false;
    let isDataFieldValid;
    if (!this.isAllRequiredQuestionAnswered()) {
      return;
    }
    let surveyQuestionResponse: SurveyQuestionResponse = this.prepareSurveyRequestPayload(
      surveyUserQualifierId,
    );
    surveyQuestionResponse.hasAnsweredAll = true;
    //surveyQuestionResponse.submit = true; //dont send this parameter to back end
    this.isSurveySuccessfullySubmitted = false;
    if(this.endSurveyMessage !== ''){
      this.isSurveySuccessfullySubmitted = true;
      this.messageResponseTemplate = this.endSurveyMessage;
    }
    for (let question of this.answeredQuestions) {
      dataValidationQuestionCount = 0;
      if(question && question.validation && question.validation.dataValidation && question.userQuestionResponse.questionTextResponse.length > 0){
        requiredDataFieldValidation = true;
        dataValidationQuestionCount = dataValidationQuestionCount + 1;
        isDataFieldValid =  await this.surveyFieldValidation(question);
        if(isDataFieldValid.status != 200){
          requiredDataFieldValidation = false;
         this.$wlToastr('error',isDataFieldValid.errors[0].description);  
         break;
        } 
      }    
    }

  if(dataValidationQuestionCount === 0 || requiredDataFieldValidation){
    const savePromise: any = vxm.jobs.saveSurveyResponse(
      {
        ...surveyQuestionResponse,
        hasAnsweredAll: false
      },
    );
    const respPromise: any = vxm.jobs.canSubmitSurveyResponse(
      surveyQuestionResponse,
    );
    this.$modal.show('survey-spinner');

    Promise.all([savePromise, respPromise]).then((resp) => {
      this.confirmSubmitSurveyPage(surveyQuestionResponse, Array.isArray(resp) && resp[1] ? resp[1] : resp);
      this.$modal.hide('survey-spinner');
    });
  }
  }

  submitSurveyResponse(surveyQuestionResponse: any){
    const respPromise: any = vxm.jobs.saveSurveyResponse(
      surveyQuestionResponse,
    );
    this.$modal.show('survey-spinner');

    Promise.all([respPromise]).then((values) => {
      if (values[0]) {
        if (values[0].success ) {
          if(this.endSurveyMessage ===''){
            this.isSurveySuccessfullySubmitted = true;
            this.messageResponseTemplate =
            values[0].surveySubmittedResponseTemplate;
          } else {
            this.$wlToastr('success',values[0].successMessage , this.$t('candidate-survey-text'));
          }
        } else {
          this.$wlToastr('error', values[0].errorMessage, this.$t('candidate-survey-text'));
        }
      }
      this.$modal.hide('survey-spinner');
    });
  }

  redirectToQuestion(changedAttributeMap: object){
    if(changedAttributeMap && Object.keys(changedAttributeMap).length){
      const sortedKeys = Object.keys(changedAttributeMap).sort((a: any, b: any) => a - b);
      const questionId = changedAttributeMap[sortedKeys[0]]['questionId'];
      this.getSurveyPageData('previous', Number(questionId)+1);
      this.showSurveySubmitScreen = false;
      this.isSurveySuccessfullySubmitted = false;
    }
  }

  confirmSubmitSurveyPage(surveyQuestionResponse: object, confirmationResponse: object) {
    if(confirmationResponse && confirmationResponse['confirmationRequired']){
      this.$modal.show(
        ConfirmationModalV2,
        this.getModalData(confirmationResponse, surveyQuestionResponse),
        {
          height: 'auto',
          clickToClose: false,
        },
      );
    } else {
      this.submitSurveyResponse(surveyQuestionResponse);
    }
  }

  getModalData(confirmationResponse: object, surveyQuestionResponse: object){
    return !confirmationResponse['validInfo'] ? {
      header: 'Confirm Changes?',
      body: 'You have updated your existing email ID or phone number while completing this survey. Please check these changes are correct.'
      + this.getchangedAttributeValues(confirmationResponse['changedAttributeMap']),
      hideCancelButton: true,
      okText: 'Go back and change answer',
      onOk: () => this.redirectToQuestion(confirmationResponse['changedAttributeMap']),
    } : {
      header: 'Confirm Changes?',
      body: 'You have updated your existing email ID or phone number while completing this survey. Please confirm if these changes are correct.'
      + this.getchangedAttributeValues(confirmationResponse['changedAttributeMap']),
      okText: 'Confirm and close survey',
      cancelText: 'Go back and change answer',
      onOk: () => this.submitSurveyResponse(surveyQuestionResponse),
      onCancel: () => this.redirectToQuestion(confirmationResponse['changedAttributeMap']),
    }
  }

  getchangedAttributeValues(changedAttributeMap: any){
    let htmlContent = '';
    Object.keys(changedAttributeMap).map((attributeKey: string) => {
      const attribute = changedAttributeMap[attributeKey];
      let content = "<p></p><div> Old "+attribute['attribute_label']+": "+ attribute['old'] +"</div>";
      content += "<div> New "+attribute['attribute_label']+": "+ attribute['new'] +"</div>";
      if(attribute['errorMsg']){
        content += "<div style=\"color: red;\">"+ attribute['errorMsg'] +"</div>";
      }
      htmlContent += content;
    })
    return htmlContent;
  }

  confirmLeaveSurveyPage() {
    this.$modal.show(
      ConfirmationModalV2,
      {
        header: this.$t('confirm-leave-survey'),
        body: this.$t('confirm-leave-survey-message'),
        okText: this.$t('leave-survey-action'),
        cancelText: this.$t('stay-on-survey-action'),
        onOk: this.goBackOrCloseTab,
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  goBackOrCloseTab() {
    // Check if there's a previous page in the browser's history.
    if (window.history.length > 1) {
      // If there's a previous page, go back to it.
      this.$router.go(-1);
    } else {
      // If there's no previous page, close the tab or window.
      window.close();
    }
  }

  isFeedbackQuestionAnswered(feedbackQuestion) {
    if (
      feedbackQuestion &&
      !(
        feedbackQuestion.userQuestionResponse &&
        feedbackQuestion.userQuestionResponse.questionTextResponse
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  isQuestionAnswered(question) {
    if(question.questionType === '04' && question.userQuestionResponse && !question.userQuestionResponse.questionTextResponse){
        return false;
    }
     else if(question.questionType === '03' && question.questionRequired &&  question.userQuestionResponse && !question.userQuestionResponse.userSingleSelect){
       return false;
    }
    else if(question.questionType === '11' && question.questionRequired && question.userQuestionResponse && !question.userQuestionResponse.questionTextResponse){
      return false;
    }
   else if (
      !(
        question.userQuestionResponse &&
        (( question.userQuestionResponse.questionTextResponse)||
          (Array.isArray(question.userQuestionResponse.userAnswerList)
            ? (question.userQuestionResponse.userAnswerList.length > 0 && question.userQuestionResponse.userAnswerList[0] !== null)
            : question.userQuestionResponse.userAnswerList)) 
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  async saveSurvey(data: any, surveyUserQualifierId: string) {
    let isAnswerValid: boolean = true;
    let dataValidationQuestionCount = 0;
    let requiredDataFieldValidation : boolean = false;
    let isDataFieldValid;
    let respPromise;
    for (let question of this.answeredQuestions) {
      isAnswerValid = this.validatePhoneAndEmailFields(question, isAnswerValid);
    }
    if (!isAnswerValid) {
      return;
    }
    let surveyQuestionResponse: SurveyQuestionResponse = this.prepareSurveyRequestPayload(
      surveyUserQualifierId,
    );

    this.isSurveySuccessfullySubmitted = false;
    for (let question of this.answeredQuestions) {
      dataValidationQuestionCount = 0;
      if(question && question.validation && question.validation.dataValidation && question.userQuestionResponse.questionTextResponse.length > 0){
        requiredDataFieldValidation = true;
        dataValidationQuestionCount = dataValidationQuestionCount + 1;
        isDataFieldValid =  await this.surveyFieldValidation(question);
        if(isDataFieldValid.status != 200){
          requiredDataFieldValidation = false;
         this.$wlToastr('error',isDataFieldValid.errors[0].description);  
         this.$refs['question_datavalidation_textarea' + question.questionID][0].focus();
         break;
        } 
      }    
    }
    if(dataValidationQuestionCount === 0 || requiredDataFieldValidation ){
      respPromise = vxm.jobs.saveSurveyResponse(
        surveyQuestionResponse,
      );
    }
    this.showSaveToaster(respPromise, true);
  }

  prepareSurveyRequestPayload(
    surveyUserQualifierId: string,
  ): SurveyQuestionResponse {
    const surveyQuestionResponse = new SurveyQuestionResponse();
    let questionResponseData: QuestionResponseData[] = [];
    this.answeredQuestions.forEach((question) => {

      let obj = {
        questionID: question.questionID,
        userQuestionResponse: { ...question.userQuestionResponse }
      };
      if (
        question.questionType === SURVEY_QUESTION_CODE_RADIO ||
        question.questionType === SURVEY_QUESTION_CODE_RATING ||
        question.questionType === SURVEY_QUESTION_CODE_DROPDOWN
      ) {
        obj.userQuestionResponse.userAnswerList = [
          obj.userQuestionResponse.userAnswerList,
        ];
      }
      if (
        question.questionType === SURVEY_QUESTION_CODE_RADIO ||
        question.questionType === SURVEY_QUESTION_CODE_RATING ||
        question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE ||
        question.questionType === SURVEY_QUESTION_CODE_DROPDOWN
      ) {
        delete obj.userQuestionResponse.questionTextResponse;
        delete obj.userQuestionResponse.videoQuestionResponse;
      } else if (
        question.questionType === SURVEY_QUESTION_CODE_TEXT ||
        question.questionType === SURVEY_FEEDBACK_QUESTION_CODE_TEXT ||
        question.questionType === SURVEY_QUESTION_CODE_UPLOAD_FILE ||
        question.questionType === SURVEY_QUESTION_CODE_DATE
      ) {
        delete obj.userQuestionResponse.userAnswerList;
        delete obj.userQuestionResponse.videoQuestionResponse;
      }
      if (question.questionType === SURVEY_QUESTION_CODE_UPLOAD_FILE ) {
        if(vxm.users.isLoggedIn){
          this.resumeListing = vxm.jobs.resumeListing;
          if (this.resumeListing.resumes.length > 0) {
            obj.userQuestionResponse.questionTextResponse = 'Resume uploaded';
          }
        }
      else{
          var emptyResumeList: ResumeWrapper = new ResumeWrapper();

          emptyResumeList.sessionValid= null,
      emptyResumeList.errorCode= null,
      emptyResumeList.errorMessage=null,
      emptyResumeList.errorMessageData= null,
      emptyResumeList.verificationResult= null,
      emptyResumeList.appExpiry= null,
      emptyResumeList.profileStrengthInfo= null,
      emptyResumeList.resumes=[]
          this.resumeListing = emptyResumeList
    
        }

      }
      
      if (question.status && question.status === '0') {
        obj.userQuestionResponse.questionTextResponse = null;
      }
      questionResponseData.push(obj);
    });
    surveyQuestionResponse.questionResponseData = questionResponseData;
    let userId = this.$route.params.userid
      ? this.$route.params.userid
      : this.$route.query.userid + '';
    if (userId) {
      surveyQuestionResponse.userId = parseInt(userId, 10);
    }
    surveyQuestionResponse.surveyId = '';
    surveyQuestionResponse.numberOfQuestions = this.answeredQuestions.length;
    surveyQuestionResponse.surveyUserQualifierId = surveyUserQualifierId;
    surveyQuestionResponse.hasAnsweredAll = false;
    return surveyQuestionResponse;
  }

  getPreviousQuestion() {
    this.getSurveyPageData('previous')
  }

  setPreviousQuestion() {
    this.showSurveySubmitScreen = false
    this.surveyData = JSON.parse(JSON.stringify(this.processSurveyResponse(this.backupResponse)))
  }

  getNextQuestionandSave() {
    if (!this.isAllRequiredQuestionAnswered()) {
      return;
    }
    this.getSurveyPageData('next')
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  updateSurveyPhone(event,question) {
    if(question){
      question.userQuestionResponse.questionTextResponse = event.nationalNumber ? '+' + event.countryCallingCode + ' ' + event.nationalNumber : event.formatInternational;
      let index = this.isQuestionPresentInArr(question);
      if (index >= 0) {
        this.answeredQuestions[index] = question;
      } else {
        this.answeredQuestions.push(question);
      }
      if(question.questionAnswered){
      question.userQuestionResponse.questionDateResponse = this.getSurveyPhone(question);
      this.phoneNumber =  question.userQuestionResponse.questionTextResponse;
      this.isPhoneValid = !event.isValid;

      }
      else{
        if(typeof event.countryCallingCode == 'undefined'){
          this.phoneNumber = '+1' + event.phoneNumber;
          question.userQuestionResponse.questionDateResponse =this.phoneNumber;
          this.isPhoneValid = true;
        }
        else{
          this.phoneNumber ='+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.isPhoneValid = !event.isValid
        question.userQuestionResponse.questionDateResponse = this.phoneNumber
      
        }

      }
    }
  }

  getSurveyPhone(phone){
    if(phone.validation && phone.validation.type === 'PHONE'){
      const questionResp = phone.userQuestionResponse;
      const phoneNum = questionResp && questionResp.questionTextResponse || phone.mappedAttributeValue;
      return phoneNum.includes('+') && phoneNum.includes(' ') 
      && phoneNum.substring(phoneNum.indexOf(' ') + 1);
    }
    return '';
  }

  format(value, event) {
    return moment(value).format(this.getCompanyDateFormat.toUpperCase());
  }

  textValidate(event, question) {
    event = event ? event : window.event;
    if (question.maxLength && (question.userQuestionResponse.questionTextResponse.length > question.maxLength ||
      (event.clipboardData && event.clipboardData.getData('text').length > question.maxLength))) {
        event.preventDefault();
    }
    if((question.validation && question.validation.type) || question.answerTypeValue){
      const val = event.key || event.clipboardData && event.clipboardData.getData('text');
      switch((question.validation && question.validation.type) || question.answerTypeValue){
        case 'NUMERIC':
        case '01':
          if(isNaN(Number(val))){
            event.preventDefault();
          }
          break;
        case 'ALPHA':
        case '02':
          if(!this.alphaRegex.test(val)){
            event.preventDefault();
          }
          break;
        case 'ALPHANUMERIC':
        case '03':
          if(!this.alphaNumericRegex.test(val)){
            event.preventDefault();
          }
          break;
        default:
          break;
      }
    }
    return true;
  }
}
